(() => {
  if (!customElements.get('ns-kit')) {
    class NailScienceKit extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('[data-ns-track]');
        const thumbs = [...this.querySelectorAll('[data-ns-thumb]')];
        const counter = this.querySelector('[data-ns-counter]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const slideCount = track?.children.length || 0;
        const go = (index) => {
          if (!track) return;
          const target = Math.max(0, Math.min(slideCount - 1, index));
          track.scrollTo({ left: track.clientWidth * target, behavior: reducedMotion ? 'auto' : 'smooth' });
        };
        const currentIndex = () => Math.round((track?.scrollLeft || 0) / (track?.clientWidth || 1));
        const updateGallery = () => {
          const index = currentIndex();
          thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
          if (counter) counter.textContent = `${index + 1} / ${slideCount}`;
        };
        thumbs.forEach((thumb) => thumb.addEventListener('click', () => go(Number(thumb.dataset.nsThumb)), { signal }));
        this.querySelector('[data-ns-prev]')?.addEventListener('click', () => go(currentIndex() - 1), { signal });
        this.querySelector('[data-ns-next]')?.addEventListener('click', () => go(currentIndex() + 1), { signal });
        track?.addEventListener('scroll', updateGallery, { passive: true, signal });
        track?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            go(currentIndex() + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, { signal });
        const form = this.querySelector('.ns-product-form');
        const updateChoice = () => {
          const selected = form?.querySelector('input[name="id"]:checked');
          if (!selected) return;
          const price = this.querySelector('[data-ns-buy-price]');
          const productLink = this.querySelector('[data-ns-product-link]');
          if (price) price.textContent = selected.dataset.nsPrice;
          if (productLink) productLink.href = selected.dataset.nsUrl;
          const quantity = this.querySelector('[data-ns-quantity]');
          if (quantity) {
            const min = Number(selected.dataset.nsMin || 1);
            const increment = Number(selected.dataset.nsIncrement || 1);
            quantity.min = String(min);
            quantity.step = String(increment);
            if (selected.dataset.nsMax) quantity.max = selected.dataset.nsMax;
            else quantity.removeAttribute('max');
            quantity.value = String(min);
          }
          const buy = this.querySelector('[data-ns-buy]');
          if (buy) {
            buy.disabled = selected.disabled;
            buy.querySelector('span').textContent = selected.disabled ? 'Sold Out' : 'Add to Cart';
          }
        };
        form?.addEventListener('change', (event) => {
          if (event.target.matches('input[name="id"]')) updateChoice();
        }, { signal });
        form?.addEventListener('submit', () => {
          const button = this.querySelector('[data-ns-buy]');
          if (button) button.setAttribute('aria-busy', 'true');
          // Ordinary Shopify product-form POST is intentional: inventory validation,
          // cart persistence, localized routes and checkout stay native to Shopify.
        }, { signal });
        updateChoice();
        const sticky = this.querySelector('.ns-kit__sticky');
        const purchase = this.querySelector('.ns-kit__purchase');
        if (sticky && purchase && 'IntersectionObserver' in window) {
          let purchaseVisible = true;
          const wrapper = document.querySelector('.page-wrapper');
          const scrollPosition = () => window.matchMedia('(min-width: 990px)').matches && wrapper ? wrapper.scrollTop : window.scrollY;
          const updateSticky = () => sticky.toggleAttribute('data-visible', !purchaseVisible && scrollPosition() > 500);
          this.observer = new IntersectionObserver(([entry]) => {
            purchaseVisible = entry.isIntersecting;
            updateSticky();
          }, { threshold: 0.1 });
          this.observer.observe(purchase);
          window.addEventListener('scroll', updateSticky, { passive: true, signal });
          wrapper?.addEventListener('scroll', updateSticky, { passive: true, signal });
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    }
    customElements.define('ns-kit', NailScienceKit);
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ns-mobile-menu__panel a');
    if (link) link.closest('details')?.removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.ns-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
  });
})();
